import { render, staticRenderFns } from "./LazySelect.vue?vue&type=template&id=2f85194a&scoped=true"
import script from "./LazySelect.vue?vue&type=script&lang=js"
export * from "./LazySelect.vue?vue&type=script&lang=js"
import style0 from "./LazySelect.vue?vue&type=style&index=0&id=2f85194a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85194a",
  null
  
)

export default component.exports